import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CONFIG from 'Config/settings';
import './style.scss';

export const Col = props => {
  const prefix = CONFIG.APP.STYLES_PREFIX;
  const className = classNames({
    [`${prefix}ikea-col-xl-${props.xl}`]: props.xl > 0,
    [`${prefix}ikea-col-lg-${props.lg}`]: props.lg > 0,
    [`${prefix}ikea-col-md-${props.md}`]: props.md > 0,
    [`${prefix}ikea-col-sm-${props.sm}`]: props.sm > 0,
    [`${prefix}ikea-col-xs-${props.xs}`]: props.xs > 0,
    [`${prefix}ikea-col`]: !props.xl && !props.lg && !props.md && !props.sm,
    [`${prefix}ikea-col-center`]: props.center,
    [props.className]: props.className
  });

  return <div className={className}>{props.children}</div>;
};

Col.propTypes = {
  xs: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  sm: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  md: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  lg: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  xl: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  center: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ])
};
